import './Auth.css';
import linkedIn from '../../Assets/Images/RegisterPage/linkedin.png';
import { useState } from 'react';
import google from '../../Assets/Images/RegisterPage/social.png';
import { useLocation, useNavigate } from 'react-router-dom';
import {  MobileVerify } from '../../services/AuthWithMobile';

function OtpVerify(){

    const location = useLocation();
    const { phoneNumber,flow } = location.state || {};
    const [otpValue1,setOtpValue1]=useState();
    const [otpValue2,setOtpValue2]=useState();
    const [otpValue3,setOtpValue3]=useState();
    const [otpValue4,setOtpValue4]=useState();

    const navigate=useNavigate();

    const [error,setError]=useState();

    async function HandleSubmit(e)
    {
        e.preventDefault();
        const otpCode=otpValue1+otpValue2+otpValue3+otpValue4;
        const mobileVerify=await MobileVerify({"phoneNumber":phoneNumber,"otp":otpCode})   

        if(flow==='register'  && mobileVerify && mobileVerify.token)
        {
            navigate('/registerwithmobileverification');
            return;
        }
        if(flow==='login' && mobileVerify && mobileVerify.token)
        {
            navigate('/profilesetup');
        }
        else
        {
            setError(mobileVerify);
        }
    }
    
    return(
        <>
             <div className='logincontainer'>
                    <form className='loginform' onSubmit={(e)=>HandleSubmit(e)}>
                           <h2 style={{fontSize:"20px"}}>OTP VERIFICATION</h2>
                           <h3 style={{fontSize:"14px"}}>Enter the OTP sent to <span>{phoneNumber}</span></h3>
                           <section className='otpinput'>
                               <input type='text' name='otpvalue1' maxLength={1} onChange={(e)=>setOtpValue1(e.target.value)}/>
                               <input type='text' name='otpvalue2' maxLength={1} onChange={(e)=>setOtpValue2(e.target.value)}/>
                               <input type='text' name='otpvalue3' maxLength={1} onChange={(e)=>setOtpValue3(e.target.value)}/>
                               <input type='text' name='otpvalue4' maxLength={1} onChange={(e)=>setOtpValue4(e.target.value)}/>
                           </section>
                           <section className='loginbuttons'>
                           <label className='mobileerror' style={{marginBottom:'5px',color:'var(--border-color)'}}>{error}</label>
                                <button className='loginbutton' type='submit'>VERIFY & CONTINUE</button>
                                <div className='orsection'>
                                    <hr  class="custom-hr"/>
                                        <h3>OR</h3>
                                    <hr  class="custom-hr"/>
                                </div>
                            </section>
                    </form>
                    <section className='socialsignin'>
                                <img src={linkedIn} alt='linkedIn' width="38" height="38"/>
                                <img src={google} alt='linkedIn' width="38" height="38"/>
                            </section>
                            <h4> New User? <span onClick={()=>window.location.href="/register"}>Register here</span></h4>
             </div>
        </>
        );
}

export default OtpVerify;